import { Utils } from '@genial/utils';
import * as zod from 'zod';

import { AssetDefaultOrSelectedTypeMap } from '../../../../../../../store/product/types';

export const getRemunerationDescription = (
  offer: AssetDefaultOrSelectedTypeMap['publicOffers']
) => {
  return `Escolha um valor entre ${Utils.Mask.Percentage(
    offer.minimumRemuneration
  )} e ${Utils.Mask.Percentage(offer.maximumRemuneration)} ${offer.relationshipIndex} ${
    offer.benchmarkName
  }`;
};

export const getEquityValueDescription = (offer: AssetDefaultOrSelectedTypeMap['publicOffers']) => {
  return `Escolha um valor entre ${Utils.Mask.Money(offer.minimumEquityValue)} e ${Utils.Mask.Money(
    offer.maximumEquityValue
  )} (faixa indicativa)`;
};

export type PublicOfferFormDataT1 = { priceItem: string };

export const getValidationCreateSchemaT1 = (minValue: number, maxValue: number) =>
  zod.object({
    priceItem: zod
      .string({
        required_error: `Valor mínimo ${Utils.Mask.Money(minValue)}`,
      })
      .refine((value) => Utils.Unmask.Money(value) >= minValue, {
        message: `Valor mínimo ${Utils.Mask.Money(minValue)}`,
      })
      .refine((value) => Utils.Unmask.Money(value) <= maxValue, {
        message: `Valor máximo ${Utils.Mask.Money(maxValue)}`,
      }),
  });

export type PublicOfferFormDataT2 = { priceItem: string; remuneration: string };

export const getValidationCreateSchemaT2 = (
  minValue: number,
  maxValue: number,
  minRemuneration: number,
  maxRemuneration: number
) =>
  zod.object({
    priceItem: zod
      .string({
        required_error: `Valor mínimo ${Utils.Mask.Money(minValue)}`,
      })
      .refine((value) => Utils.Unmask.Money(value) >= minValue, {
        message: `Valor mínimo ${Utils.Mask.Money(minValue)}`,
      })
      .refine((value) => Utils.Unmask.Money(value) <= maxValue, {
        message: `Valor máximo ${Utils.Mask.Money(maxValue)}`,
      }),
    remuneration: zod
      .string({
        required_error: `Remuneração mínima ${Utils.Mask.Percentage(minRemuneration)}`,
      })
      .refine((value) => Utils.Unmask.DecimalPercentage(value) >= minRemuneration, {
        message: `Remuneração mínima ${Utils.Mask.Percentage(minRemuneration)}`,
      })
      .refine((value) => Utils.Unmask.DecimalPercentage(value) <= maxRemuneration, {
        message: `Remuneração máxima ${Utils.Mask.Percentage(maxRemuneration)}`,
      }),
  });

export type PublicOfferFormDataT3 = { priceItem: string; equityValue: string };

export const getValidationCreateSchemaT3 = (
  minValue: number,
  maxValue: number,
  minEquityValue: number,
  maxEquityValue: number
) =>
  zod.object({
    priceItem: zod
      .string({
        required_error: `Valor mínimo ${Utils.Mask.Money(minValue)}`,
      })
      .refine((value) => Utils.Unmask.Money(value) >= minValue, {
        message: `Valor mínimo ${Utils.Mask.Money(minValue)}`,
      })
      .refine((value) => Utils.Unmask.Money(value) <= maxValue, {
        message: `Valor máximo ${Utils.Mask.Money(maxValue)}`,
      }),
    equityValue: zod
      .string({
        required_error: `Valor mínimo ${Utils.Mask.Money(minEquityValue)}`,
      })
      .refine((value) => Utils.Unmask.Money(value) >= minEquityValue, {
        message: `Valor mínimo ${Utils.Mask.Money(minEquityValue)}`,
      })
      .refine((value) => Utils.Unmask.Money(value) <= maxEquityValue, {
        message: `Valor máximo ${Utils.Mask.Money(maxEquityValue)}`,
      }),
  });

export type PublicOfferFormDataT4 = { priceItem: string };

export const getValidationCreateSchemaT4 = (minValue: number, maxValue: number) =>
  zod.object({
    priceItem: zod
      .string({
        required_error: `Valor mínimo ${Utils.Mask.Money(minValue)}`,
      })
      .refine((value) => Utils.Unmask.Money(value) >= minValue, {
        message: `Valor mínimo ${Utils.Mask.Money(minValue)}`,
      })
      .refine((value) => Utils.Unmask.Money(value) <= maxValue, {
        message: `Valor máximo ${Utils.Mask.Money(maxValue)}`,
      }),
  });
